export default {
  setEmailBadge(state, data) {
    state.emailBadge = data;
  },

  setQuotesValueBadge(state, data) {
    state.quotesValueBadge = data;
  },

  setQuotesBadge(state, data) {
    state.quotesBadge = data;
  },

  setConversion(state, data) {
    state.conversion = data;
  },

  setNationality(state, data) {
    state.nationality = data;
  },

  setStagioni(state, data) {
    state.stagioni = data;
  },

  setTotalRequest(state, data) {
    state.totalRequest = data;
  },

  setNationalityConversion(state, data) {
    state.nationalityConversion = data;
  },
};
